import { useMutation } from '@apollo/client'
import { graphql } from '@apollo/client/react/hoc'

import { atlasClient } from 'graphql/client'
import { atlas, graphene } from 'graphql/tags'

const batchUpsertOrderEvents = graphene`#graphql
  mutation batchUpsertOrderEvents($input: BatchUpsertOrderEventsInput!) {
    batchUpsertOrderEvents(input: $input) {
      updatedOrders {
        id
        eventName
        eventCode
      }
      notUpdatedOrders {
        id
        eventName
        eventCode
      }
    }
  }
`

export const withEditEventsMutation = graphql(batchUpsertOrderEvents, {
  props: ({ mutate }) => ({
    handleEditEvents: (selectedOrders, selectedOption) =>
      mutate({
        variables: {
          input: {
            eventId: selectedOption,
            orderIds: selectedOrders,
          },
        },
      }),
  }),
})

const bulkSetToReexport = atlas`#graphql
  mutation BulkSetOrdersToReexport($input: BulkSetOrdersToReexportInput!) {
    bulkSetOrdersToReexport(input: $input) {
      updatedOrderIds
    }
  }
`

export const useBulkSetToReexport = () => {
  const [bulkSetToReexportAction] = useMutation(bulkSetToReexport, {
    client: atlasClient,
  })
  const onBulkSetToReexportAction = async (orderIds) => {
    const response = await bulkSetToReexportAction({
      variables: {
        input: {
          orderIds,
        },
      },
    })
    return response
  }
  return onBulkSetToReexportAction
}

export const withBatchSetToReexportMutation = (WrappedComponent) => (props) => {
  const customProps = {
    ...props,
    handleSetToReexport: useBulkSetToReexport(),
  }
  return <WrappedComponent {...customProps} />
}
